import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { reasons } from 'constants/vehicle';
import { Autocomplete } from 'components/FormFields';
import { handleShowError, handleError, generateFilterOptions } from 'utils';

const VehicleReasonsSelect = ({
  label,
  variant,
  field: { name, value },
  form: { errors, touched, setFieldValue },
  omitFields,
  asyncErrors,
  margin,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [defaultValue, setDefaultValue] = useState(null);
  const filterOptions = generateFilterOptions('start', 'label');
  useEffect(() => {
    if (value || value === '') {
      const defaultVal = reasons.find((reason) => reason === value);
      if (defaultVal) {
        setDefaultValue(i18n.t(`reasons.${defaultVal}`));
      } else {
        setDefaultValue(null);
      }
    }
  }, [value, reasons]) // eslint-disable-line

  return (
    <Autocomplete
      openOnFocus
      label={label}
      margin={margin}
      variant={variant}
      id="vehicle-reasons"
      inputValue={inputValue}
      defaultValue={defaultValue}
      filterOptions={filterOptions}
      onInputChange={(ev, val) => setInputValue(val || '')}
      error={handleError(name, errors, touched, asyncErrors)}
      onChange={(ev, val) => setFieldValue(name, val || '')}
      options={reasons.filter((val) => omitFields.indexOf(val))}
      getOptionLabel={(option) => i18n.t(`reasons.${option}`, { defaultValue: option })}
      getOptionSelected={(option, value) =>
        i18n.t(`reasons.${option}`, { defaultValue: option }) === value || ''
      }
      helperText={handleShowError(name, errors, touched, asyncErrors)}
    />
  );
};

VehicleReasonsSelect.propTypes = {
  label: PropTypes.string,
  asyncErrors: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  style: PropTypes.object,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
  omitFields: PropTypes.array,
};

VehicleReasonsSelect.defaultProps = {
  required: true,
  disabled: false,
  form: {
    errors: {},
    touched: {},
    setFieldValue: () => {},
  },
  style: {},
  field: {},
  variant: 'standard',
  label: 'Reason',
  omitFields: [],
};

export default VehicleReasonsSelect;
